<template>
  <div class="piggery bg-white">
    <div class="banner">
    <!-- <div class="video-bannar"> -->
      <video class="video" autoplay muted loop>
        <source :src="videoUrl" type="video/mp4">
      </video>
      <div class="shade-img"></div>
    </div>
      <!-- <h1 class="video-font">用AI和大数据打造智能猪场</h1> -->
    <!-- </div> -->

    <div class="middle-content bg-white">
      <div class="group-item">
        <router-link :to="{name: 'piggery'}">
        <div class="group-l home-img1">
          <div class="wrap-mask-2">
            <div class="content">
              <p class="title mb-15">猪小智模式</p>
              <p class="detail">智能猪场管理专家</p>
            </div>
          </div>
        </div>
        </router-link>
        <div class="group-r">
          <router-link :to="{name: 'EPC'}">
          <div class="gove home-img2">
            <div class="wrap-mask-3">
              <div class="content">
                <p class="title mb-15">EPC模式</p>
                <p class="detail">一体化建设方案 助推产业升级</p>
              </div>
            </div>
          </div>
          </router-link>
          <!-- <router-link :to="{name: 'finance'}"> -->
          <div class="pig home-img3">
            <div class="wrap-mask-3">
              <div class="content">
                <p class="title mb-15">金融模式</p>
                <p class="detail">用农信的钱，购买农信商城的“优选产品”，<span>养好您的猪！</span></p>
              </div>
            </div>
          </div>
          <!-- </router-link> -->
        </div>
      </div>

      <router-link :to="{name: 'coreCompetence'}">
      <div class="home-item home-img4">
        <div class="content-r">
          <h1>农芯智能猪场</h1>
          <p>秉承“远程化养猪，智能化管猪” 核心理念</p>
          <p>基于云计算、物联网、大数据、人工智能等技术</p>
          <p>提供系统、科学的智能猪场整体解决方案</p>
        </div>
      </div>
      </router-link>

      <router-link :to="{name: 'coreCompetence', query:{location:'contact'}}">
      <div class="home-item home-img5">
        <div class="content-l">
          <h1>农芯数科 伴您智慧养殖</h1>
          <p>提供智能猪场整体解决方案</p>
          <router-link :to="{name: 'coreCompetence', query:{location:'base'}}"><p class="font-15">联系我们 ></p></router-link>
        </div>
      </div>
      </router-link>

    </div>
  </div>
</template>

<script>
import { getSession, setSession } from '@/utils/index'
const imgSrc = 'http://image-ali.bianjiyi.com/1/2018/0525/11/15272184814119.JPG'
const videoUrl = process.env.VUE_APP_VIDEO_URL
export default {
  data () {
    return {
      imgSrc: imgSrc,
      videoUrl: videoUrl
    }
  },
  mounted () {
    this.getAllEnum()
    if (!getSession('bannerPic')) {
      this.getBannerPage()
    }
    var element = document.querySelector('.video')
    // eslint-disable-next-line no-undef
    objectFitPolyfill(element)
  },
  methods: {
    getAllEnum () {
      this.API.basic.getAllEnum().then((res) => {
        console.log(res)
        setSession('fieldType', res.data.fieldType)
        setSession('consultObjective', res.data.consultObjective)
      })
    },
    /**
     * 获取 banner 图片
     */
    async getBannerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100
      }
      const res = await this.API.basic.getBannerPage(params) || []
      // eslint-disable-next-line prefer-const
      let arr = {}
      if (res.data.length > 0) {
        res.data.map(o => {
          this.$set(arr, o.remark, { picUrl: o.pictureUrl, connection: o.connection })
        })
        setSession('bannerPic', arr)
      }
    }
  }
}
</script>
